import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.css'],
  standalone: false
})
export class ChipComponent {
  /** Leading caption, e.g. "T.C.K" or "SMS". */
  @Input() label = '';
  /** Optional value rendered after the label as "label · value". */
  @Input() value: string | null | undefined;
  /** Optional Phosphor icon class. */
  @Input() icon = '';
}
